/* eslint react/no-unused-prop-types: 0 */
/* eslint no-useless-escape: 0 */
import PropTypes from 'prop-types'
import { Dropdown, FormSelect, SearchResult, Select } from 'semantic-ui-react'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

Dropdown.propTypes.options = PropTypes.any
Dropdown.propTypes.meta = PropTypes.any
Select.propTypes.options = PropTypes.any
FormSelect.propTypes.options = PropTypes.any
SearchResult.propTypes.title = PropTypes.any

const masks = {
  date: {
    // MM/DD/YYYY. Rendered unguided (see FormInput's `guide` prop): a guided
    // date field shows `__/__/____` placeholder chars inside the value, which
    // then reach form state as part of the stored string.
    mask: [
      /[0-1]/,
      /[0-9]/,
      '/',
      /[0-9]/,
      /[0-9]/,
      '/',
      /[1-2]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
    ],
    defaultPlaceholder: 'mm/dd/yyyy',
  },
  phone: {
    mask: [
      '(',
      /[1-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
    defaultPlaceholder: '(123) 456-7890',
  },
  integer: {
    mask: createNumberMask({ prefix: '', includeThousandsSeparator: false }),
    defaultPlaceholder: '0',
  },
  number: {
    mask: createNumberMask({ prefix: '', includeThousandsSeparator: true }),
    defaultPlaceholder: '0',
  },
  decimal: {
    // Plain fractional number, no prefix and no thousands separator: the
    // accessorial duration properties (detention hours, min 0.25) are typed as
    // bare decimals. allowLeadingZeroes: see the currency mask — a field
    // reading 0 would otherwise conform every further keystroke back to 0.
    mask: createNumberMask({
      prefix: '',
      allowDecimal: true,
      allowLeadingZeroes: true,
      includeThousandsSeparator: false,
    }),
    defaultPlaceholder: '0.00',
  },
  currency: {
    // allowLeadingZeroes must stay true: with it off, createNumberMask strips the
    // leading zero and leaves a single digit slot, so a field reading $0 conforms
    // every further keystroke back to $0 — $0 could never be edited into $500,
    // and cents typed as .01 were unreachable. A transient $05 while typing is
    // re-formatted from the stored number on blur (FormInput.logic.js draft).
    mask: createNumberMask({
      prefix: '$',
      allowLeadingZeroes: true,
      allowDecimal: true,
    }),
    // A format hint, like every other mask here — not a field label. This read
    // 'Order Price', which FormInput then showed on every currency field in the
    // app (lane Price, lane Carrier Price, Line Haul, Carrier Price Override),
    // because a mask placeholder used to outrank the caller's own placeholder.
    defaultPlaceholder: '$0.00',
  },
  zip: {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
    defaultPlaceholder: '55555',
  },
  percent: {
    // allowLeadingZeroes: see the currency mask — a field reading 0% was locked
    mask: createNumberMask({
      prefix: '',
      suffix: '%',
      allowLeadingZeroes: true,
      allowDecimal: true,
      integerLimit: 3,
      decimalLimit: 2,
    }),
    defaultPlaceholder: '0-100%',
  },
}

const sanitizeMask = (mask, value) => {
  if (['integer', 'number', 'percent', 'decimal'].includes(mask)) {
    return +value.replace(/[^0-9.]/g, '')
  }
  if (['currency'].includes(mask)) {
    return +value.replace(/[^0-9.]/g, '')
  }
  if (mask === 'zip') {
    return value.replace(/_/g, '')
  }
  return value
}

export { masks, sanitizeMask }
